/* eslint-disable no-unused-vars */
/* ICONS */
import { MdOutlineInventory2 } from "react-icons/md";
import { FiShoppingCart } from "react-icons/fi";
import { BiCategory } from "react-icons/bi";
import { LuTags } from "react-icons/lu";
import { IoHeadsetOutline, IoMailOutline } from "react-icons/io5";

export const navSections = [
  {
    title: "MANAGE STORE",
    items: [
      {
        id: "orders",
        link: "/orders",
        icon: FiShoppingCart,
        name: "Orders",
        disabled: false,
      },
    ],
  },
  {
    title: "MANAGE PRODUCTS",
    items: [
      {
        id: "inventory",
        link: "/inventory",
        icon: MdOutlineInventory2,
        name: "Inventory",
        disabled: true,
      },
      {
        id: "categories",
        link: "/categories",
        icon: BiCategory,
        name: "Categories",
        disabled: true,
      },
      {
        id: "tags",
        link: "/tags",
        icon: LuTags,
        name: "Tags",
        disabled: true,
      },
    ],
  },
  {
    title: "MANAGE QUERIES",
    items: [
      {
        id: "contact-us",
        link: "/contact-us",
        icon: IoHeadsetOutline,
        name: "Contact Us",
        disabled: false,
      },
      {
        id: "newsletter",
        link: "/newsletter",
        icon: IoMailOutline,
        name: "Newsletter",
        disabled: false,
      },
    ],
  },
];

const navMenu = navSections.flatMap((section) => section.items);

export default navMenu;
